import getDataAccessPolicy from "./getDataAccessPolicy";
import createDataAccessPolicy from "./createDataAccessPolicy";
import editDataAccessPolicy from "./editDataAccessPolicy";

const DataAccessPolicy = {
    getDataAccessPolicy,
    createDataAccessPolicy,
    editDataAccessPolicy,
}
export default DataAccessPolicy